"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconLibrary = require("../../packages/IconLibrary");
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const CloseButton = function (_ref) {
  let {
    theme,
    size,
    disableBackground = false,
    brand,
    toyotaIcon,
    lexusIcon,
    ariaLabel,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.CloseButton, {
    theme: theme,
    size: size,
    disableBackground: disableBackground,
    "aria-label": ariaLabel ? ariaLabel : "Close",
    ...rest,
    "data-testid": "CloseButton",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Icon, {
      children: brand === "toyota" ? toyotaIcon ? toyotaIcon : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.CloseHeavy, {}) : lexusIcon ? lexusIcon : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.Close, {})
    })
  });
};
var _default = exports.default = CloseButton;